import constant from "./constant";
export const zoom = () => {
    // console.log('zoom')
    let x = window.innerWidth / constant.constant.PAGE_WIDTH;
    let y = window.innerHeight / constant.constant.PAGE_HEIGHT;
    let oBody = document.getElementsByTagName('body')[0];
    oBody.style.transform = `scale(${x}, ${y})`;
    oBody.style.webkitTransform = `scale(${x}, ${y})`;/* for Chrome || Safari */
    oBody.style.msTransform = `scale(${x}, ${y})`;/* for Firefox */
    oBody.style.mozTransform = `scale(${x}, ${y})`;/* for IE */
    oBody.style.oTransform = `scale(${x}, ${y})`;/* for Opera */
}

export const textFormat = text => {
    if (text == '') {
        return 0;
    } else {
        var num = text.toFixed().replace(/(\d)(?=(\d{3}))/g, '$1,')//超过3位数时，加入逗号

        return num
    }
}

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}


/**
 * 获取上周、本周、上月、本月、上季度、本季度的开始日期、结束日期 start
 * 亲测无bug。获取上月开始结束日期考虑了年份的变化
 */
var now = new Date(); //当前日期
var nowDayOfWeek = now.getDay() - 1; //今天本周的第几天
var nowDay = now.getDate(); //当前日
var nowMonth = now.getMonth(); //当前月
var nowYear = now.getYear(); //当前年
nowYear += (nowYear < 2000) ? 1900 : 0; //
var lastMonthDate = new Date(); //上月日期
lastMonthDate.setDate(1);
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
var lastYear = lastMonthDate.getYear();
var lastMonth = lastMonthDate.getMonth();

//获得某月的天数
function getMonthDays (myMonth) {
    var monthStartDate = new Date(nowYear, myMonth, 1);
    var monthEndDate = new Date(nowYear, myMonth + 1, 1);
    var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
    return days;
}

//获得本季度的开始月份
function getQuarterStartMonth () {
    var quarterStartMonth = 0;
    if (nowMonth < 3) {
        quarterStartMonth = 0;
    }
    if (2 < nowMonth && nowMonth < 6) {
        quarterStartMonth = 3;
    }
    if (5 < nowMonth && nowMonth < 9) {
        quarterStartMonth = 6;
    }
    if (nowMonth > 8) {
        quarterStartMonth = 9;
    }
    return quarterStartMonth;
}

//获得本周的开始日期
export const getWeekStartDate = () => {
    var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
    return weekStartDate
}

//获得本周的结束日期
export const getWeekEndDate = () => {
    var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));
    return weekEndDate
}

//获得上周的开始日期
export const getLastWeekStartDate = () => {
    var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 7);
    return weekStartDate
}
//获得上周的结束日期
export const getLastWeekEndDate = () => {
    var weekEndDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 1);
    return weekEndDate
}
//获得本月的开始日期
export const getMonthStartDate = () => {
    var monthStartDate = new Date(nowYear, nowMonth, 1);
    return monthStartDate
}
//获得本月的结束日期
export const getMonthEndDate = () => {
    var monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
    return monthEndDate
}
//获得上月开始时间
export const getLastMonthStartDate = () => {
    if (lastMonth == 11) {
        var lastMonthStartDate = new Date(nowYear - 1, lastMonth, 1);
    } else {
        var lastMonthStartDate = new Date(nowYear, lastMonth, 1);
    }
    return lastMonthStartDate
}
//获得上月结束时间
export const getLastMonthEndDate = () => {
    if (lastMonth == 11) {
        var lastMonthEndDate = new Date(nowYear - 1, lastMonth, getMonthDays(lastMonth));
    } else {
        var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
    }
    return lastMonthEndDate
}
//获得本季度的开始日期
export const getQuarterStartDate = () => {
    var quarterStartDate = new Date(nowYear, getQuarterStartMonth(), 1);
    return quarterStartDate
}
//获得本季度的结束日期
export const getQuarterEndDate = () => {
    var quarterEndMonth = getQuarterStartMonth() + 2;
    var quarterStartDate = new Date(nowYear, quarterEndMonth,
        getMonthDays(quarterEndMonth));
    return quarterStartDate
}

//获得上季度的开始日期
export const getLastQuarterStartDate = () => {
    //如果是第一季度，则上季度开始是上一年
    //month从0开始为第一月
    let January = 0
    let October = 9
    let ifLastYear = getQuarterStartMonth() == January ? 1 : 0
    var lastQuarterStartDate = new Date(nowYear - ifLastYear, ifLastYear ? October : (getQuarterStartMonth() - 3), 1);

    return lastQuarterStartDate
}
//获得上季度的结束日期(上季最后一天)
export const getLastQuarterEndDate = () => {
    //如果是第一季度，则上季度开始是上一年
    let January = 0
    let December = 11//12月
    let ifLastYear = getQuarterStartMonth() == January ? 1 : 0
    let mon = ifLastYear ? December : (getQuarterStartMonth() - 1)
    var lastQuarterEndDate = new Date(nowYear - ifLastYear, mon, getMonthDays(mon));

    return lastQuarterEndDate
}

//获得上年的开始日期
export const getLastYearStartDate = () => {

    var lastYearStartDate = new Date(nowYear - 1, 0, 1);

    return lastYearStartDate
}

//获得上年的结束日期
export const getLastYearEndDate = () => {

    var lastYearStartDate = new Date(nowYear - 1, 11, 31);

    return lastYearStartDate
}



//获得本年的结束日期
export const getYearEndDate = () => {

    var yearStartDate = new Date(nowYear, 11, 31);

    return yearStartDate
}

//获得本年的开始日期
export const getYearStartDate = () => {
    var yearStartDate = new Date(nowYear, 0, 1);
    return yearStartDate
}

//获取最近一周(前7天)
export const getLastWeekDate = () => {
    var lastWeekDate = new Date(nowYear, nowMonth, nowDay - 7);
    return lastWeekDate
}

export function parseTime (time, cFormat) {
    if (!time) {
        return
    }
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') return ['日', '一', '二', '三', '四', '五', '六'][value]
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}
